<template>
  <section class="landing-page-employers">
    <PublicNavigation :showForm="showForm" />
    <div class="main-header">
      <div class="center-text">
        <div class="text">
          <img :src="require(`../../../public/img/landing-pages/Jobshark_light.png`)" />
          <h1>Join The New Community for <span>IT professionals and employers</span></h1>
        </div>
      </div>
    </div>
    <div class="content-section-gray">
      <div class="container">
        <div class="content">
          <h2>JOB ADVERTISING IS <span>NOW ENTIRELY FREE!</span></h2>
          <p>
            We believe that job posting should be free and that is exactly what you get with the new
            Jobshark! But it gets better than that; with a user-friendly interface and a range of
            powerful tracking features, Jobshark empowers you to find your next exceptional employee
            faster, easier, and more accurate than ever before.
          </p>
          <div class="d-flex">
            <button @click="showFormEvent('employer')" class="btn btn-primary">
              POST YOUR JOB AD FOR FREE!
            </button>
          </div>
          <section class="brands">
            <div class="container">
              <carousel
                :autoplay="true"
                :nav="false"
                :items="4"
                :margin="40"
                :responsive="{
                  0: { items: 2, nav: false },
                  576: { items: 3, nav: false },
                  768: { items: 3, nav: false },
                  992: { items: 4, nav: false },
                  1200: { items: 5, nav: false },
                }"
              >
                <img
                  v-for="brand in brands"
                  :key="brand.id"
                  class="lgx-logo-img"
                  :src="require(`../../../public/img/homepage/customer-logos/${brand.src}`)"
                  style="max-width: 350px; max-height: 350px"
                  :alt="brand.alt"
                  :title="brand.alt"
                />
              </carousel>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div class="content-section-white">
      <div class="container">
        <div class="content">
          <h3>HOW DOES IT WORK?</h3>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>POST YOUR <span>JOB AD FOR FREE</span></h3>
              </div>
              <div class="col-md-6">
                <p>
                  Craft your compelling job ad with our job ad generator and post it for free on our
                  platform. Attract top IT talent by showcasing your company's unique value
                  proposition, work culture and the exciting opportunities you offer.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number">1</span>
              <img
                :src="require(`../../../public/img/landing-pages/jobshark-jobs-job-board.jpg`)"
              />
            </div>
          </div>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>Track your <span>hiring progress</span></h3>
              </div>
              <div class="col-md-6">
                <p>
                  Effortlessly manage the hiring process through our intuitive dashboards. Stay
                  organized, track applications, schedule interviews, and gain valuable insights
                  into your recruitment progress through our modern interface.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number">2</span>
              <img
                :src="require(`../../../public/img/landing-pages/jobshark-candidate-stages.jpg`)"
              />
            </div>
          </div>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>SEAMLESS EMAIL <span>INTEGRATION</span></h3>
              </div>
              <div class="col-md-6">
                <p>
                  Communicate effectively with candidates using our built-in email integration
                  feature that requires no complicated setup. From initial contact and screening to
                  interview scheduling and offer management, maintain transparent and seamless
                  communication throughout the hiring journey.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number upper">3</span>
              <img
                :src="require(`../../../public/img/landing-pages/seamless-email-integration.jpg`)"
              />
            </div>
          </div>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>MEASURE <span>PERFORMANCE</span> <span>WITH PIPELINES</span></h3>
              </div>
              <div class="col-md-6">
                <p>
                  Gain an overview of your open positions and their progress with our pipelines
                  feature with recruiting stages. Measure performance, identify delays, and optimize
                  your hiring strategy for faster and more efficient results.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number">4</span>
              <img
                :src="require(`../../../public/img/landing-pages/pipeline-tracking-system.jpg`)"
              />
            </div>
          </div>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>UNLOCK PREMIUM <span>MANAGED SERVICES</span></h3>
              </div>
              <div class="col-md-6">
                <p>
                  Take advantage of our premium managed services, such as headhunting to boost the
                  inflow of skilled candidates. Benefit from personalized assistance in identifying
                  and recruiting talent for both short and long-term engagements.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number upper">5</span>
              <img
                :src="require(`../../../public/img/landing-pages/premium-managment-services.jpg`)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-section-gray">
      <div class="container">
        <div class="content no-padding">
          <h2 class="bold">WHY JOIN JOBSHARK?</h2>
          <h2 class="sm">
            WITH SO MANY JOB BOARDS OUT THERE,
            <span>HERE IS HOW WE GIVE YOU A COMPETITIVE EDGE: </span>
          </h2>
          <div class="row">
            <div class="col-md-6">
              <div class="cube">
                <img :src="require(`../../../public/img/landing-pages/Icon-08.png`)" />
                <h3>
                  ADVERTISING IS<br />
                  ENTIRELY FOR FREE
                </h3>
                <p>
                  Advertising is entirely for free, no hidden fees or charges, empowering companies
                  to reach active job-seeking IT professionals in a very cost-efficient way.
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="cube">
                <img :src="require(`../../../public/img/landing-pages/Icon-09.png`)" />
                <h3>
                  A TOP-MODERN JOB BOARD<br />
                  FOCUSED ENTIRELY ON IT JOBS
                </h3>
                <p>
                  Experience a top-modern job board exclusively focused on IT jobs, designed to
                  streamline your hiring process, connect you with the best IT talent, and provide
                  valuable insights for making informed hiring decisions, ultimately propelling your
                  company's success.
                </p>
              </div>
            </div>

            <div class="col-md-6">
              <div class="cube">
                <img :src="require(`../../../public/img/landing-pages/Icon-10.png`)" />
                <h3>
                  PERSONALIZED SUPPORT<br />
                  AND ADVISORY
                </h3>
                <p>
                  Our dedicated team offers personalized support and expert advisory services to
                  streamline your hiring process, ensuring you find the perfect fit for your
                  company.
                </p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="cube">
                <img :src="require(`../../../public/img/landing-pages/Icon-11.png`)" />
                <h3>
                  STAY ORGANIZED AND MAKE<br />
                  DATA-DRIVEN DECISIONS
                </h3>
                <p>
                  Streamline your hiring process with our intuitive dashboards, enabling you to stay
                  organized and make informed, data-driven decisions for successful talent
                  acquisition.
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 mx-auto">
              <button
                @click="showFormEvent('employer')"
                v-observe-visibility="animateButton"
                class="btn btn-secondary btn-block"
              >
                Sign me up!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="black-section">
      <div class="col-md-8 mx-auto">
        <div class="d-flex items-center">
          <img :src="require(`../../../public/img/landing-pages/Icon-12.png`)" />
          <div class="text d-flex">
            <div>
              <p>
                WHETHER YOU'RE STARTING OUT OR SCALING UP, GROW YOUR IT TEAM FASTER WITH JOBSHARK.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="intend" class="on-exit animate__animated animate__fadeIn animate__fast">
      <div class="box">
        <div class="content">
          <span @click="intend = false" class="close-button">X</span>
          <div class="text">
            <h3>Wait! Before you go</h3>
            <p>
              Register now to claim your privilege of advertising jobs <strong>FOR FREE</strong> on
              Jobshark whenever you need them.
            </p>
            <p class="mb-4">
              Open a free account and start receiving relevant applications! It only takes 2
              minutes.
            </p>
            <button @click="showFormEvent('employer')" class="btn btn-secondary">
              Sign up for free!
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PublicNavigation from '../../components/Navigations/PublicNavigation';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import VerificationCodeEmployer from '../PublicPagesBase/VerificationCodeEmployer';
import Spinner from '../../components/common/LoadingSpinner/Spinner';
import { BRANDS } from '../../constants';
import carousel from 'vue-owl-carousel';
import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import exitIntent from 'exit-intent';
import axios from 'axios';
Vue.directive('observe-visibility', ObserveVisibility);
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [titleMixin],
  title: 'Discover Jobshark & Boost your IT Recruitment | Jobshark',
  components: {
    CustomMainModal,
    carousel,
    PublicNavigation,
    VerificationCodeEmployer,
    Spinner,
  },
  data: () => ({
    showForm: {
      formType: '',
      count: 0,
    },
    brands: BRANDS,
    intend: false,
    retoken: '',
    isLoading: false,
    jobAds: [],
    promotedJobAds: [],
    sendLocation: [],
    keywords: [],
    locationsOptions: [],
    postFreeJob: {
      phone: '',
      email: '',
      companyName: '',
      countryId: '',
      address: '',
      postal: '',
      city: '',
      cityId: '',
      countryName: '',
      corporateWebsite: '',
      firstName: '',
      lastName: '',
      password: '',
      phone_code: '',
      isAgree: false,
      campaign_id: null,
      campaign_medium: null,
      campaign_name: null,
      campaign_source: null,
    },
  }),
  methods: {
    ...mapActions([
      'fetchAllJobResults',
      'retrieveEmployersDropdownCandidate',
      'retrieveCompetencesList',
      'searchLocationByName',
      'retrieveCitiesListByCountryId',
      'retrieveLanguagesList',
      'retrieveAllCountries',
    ]),
    showFormEvent(type) {
      this.showForm.formType = type;
      this.showForm.count++;
    },
    handleExitIntent() {
      this.intend = true;
    },
    animateDiv(isVisible, entry) {
      if (isVisible) {
        let domElement = entry.target;
        domElement.classList.add('animate__animated', 'animate__fadeInUp');
      }
    },
    animateButton(isVisible, entry) {
      if (isVisible) {
        let domElement = entry.target;
        domElement.classList.add('animate__animated', 'animate__bounceIn');
      }
    },
    toggleForms() {
      this.showVerification = false;
    },

    getDefaultCountry() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/address/getaddressbyip`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.postFreeJob.countryName = data.country_name;
          this.postFreeJob.countryId = data.country_id;
          this.postFreeJob.phone_code = data.country_name;
          this.postFreeJob.phone = `${data.phone_code} `;
          this.postFreeJob.city = data.city_name;
          this.postFreeJob.cityId = data.city_id;
          this.postFreeJob.postal = data.city_postal_code;

          this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
        });
    },

    addCountryCode(code) {
      this.postFreeJob.phone_code = code.replace(/[0-9+]/g, '');
      this.postFreeJob.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },

    next() {
      if (this.step < 2) {
        this.step++;
      }
    },
    prev() {
      this.step--;
    },

    validate(el) {
      if (el.target.required === true && el.target.value === '') {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }

      if (el.target.type === 'email') {
        this.validateEmail(this.postFreeJob.email);
      }

      if (el.target.type === 'password' && el.target.value.length < 8) {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }
    },

    validateEmail(email) {
      const emailRe = /^(([^<>()[\]\\.,;:#/\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // const emailRe = /^(([^<>()\[\]\\.,;:#/\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.length > 0) {
        if (emailRe.test(email)) {
          this.postFreeJob.emailNotFalid = false;
          this.postFreeJob.emailValidated = true;
        } else {
          this.postFreeJob.emailNotFalid = true;
          this.postFreeJob.emailValidated = false;
        }
      }
    },

    fetchOptions(search, loading) {
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;
            const concatedLists = [].concat(countriesList, citiesList);
            this.locationsOptions = concatedLists;
            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },

    fetchCitisByC(e) {
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
    },
    openPostJob() {
      this.showModalJob = true;
    },

    fetchCitisByCountryId(e) {
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
    },

    getCaptcha() {
      let vm = this;
      const REG = () => this.registerEmployer();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.reToken = token;
          REG();
        });
    },

    registerEmployer() {
      if (!this.postFreeJob.isAgree) {
        this.$toasted.error(
          `Please agree to Jobshark's General Conditions for Employers to register`,
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }

      this.isLoading = true;

      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/manager/auth/register`,
        data: {
          email: this.postFreeJob.email,
          password: this.postFreeJob.password,
          company_name: this.postFreeJob.companyName,
          first_name: this.postFreeJob.firstName,
          last_name: this.postFreeJob.lastName,
          city_id: this.postFreeJob.cityId,
          country_id: this.postFreeJob.countryId,
          street_address: this.postFreeJob.address,
          website: this.postFreeJob.corporateWebsite,
          phone_number: this.postFreeJob.phone,
          country_code: this.postFreeJob.phone_code,
          postal_code: this.postFreeJob.postal,
          privacy: this.postFreeJob.isAgree,
          'g-recaptcha-response': this.reToken,
          campaign_id: this.postFreeJob.campaign_id,
          campaign_medium: this.postFreeJob.campaign_medium,
          campaign_name: this.postFreeJob.campaign_name,
          campaign_source: this.postFreeJob.campaign_source,
        },
      })
        .then(response => {
          localStorage.setItem('uuid', response.data.id);

          this.showVerification = true;
          this.isLoading = false;
        })

        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(`${err.response.data.message}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    openModal(e) {
      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'register-btn') {
        this.modalTitle = 'Register';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Register';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    },
    getCampainParams() {
      if (this.$route.query.utm_id) {
        this.postFreeJob.campaign_id = this.$route.query.utm_id;
      }
      if (this.$route.query.utm_medium) {
        this.postFreeJob.campaign_medium = this.$route.query.utm_medium;
      }
      if (this.$route.query.utm_campaign) {
        this.postFreeJob.campaign_name = this.$route.query.utm_campaign;
      }
      if (this.$route.query.utm_source) {
        this.postFreeJob.campaign_source = this.$route.query.utm_source;
      }
    },
  },
  watch: {
    postFreeJob: {
      handler(val) {
        if (val.companyName && val.countryId && val.address && val.postal && val.cityId) {
          this.nextStep = true;
        } else {
          this.nextStep = false;
        }
        if (
          this.nextStep &&
          val.firstName &&
          val.lastName &&
          val.password.length >= 8 &&
          val.phone &&
          val.email.length > 0
        ) {
          this.canPost = true;
        } else {
          this.canPost = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      'getNextPage',
      'getTotalPages',
      'getCurrentPage',
      'getAllCountries',
      'allSearchJobResults',
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getEmployersDropdownCandidate',
    ]),
  },
  mounted() {
    this.getDefaultCountry();
    this.getCampainParams();
    setTimeout(() => {
      this.removeExitIntent = exitIntent({
        threshold: 10,
        maxDisplays: 1,
        eventThrottle: 200,
        onExitIntent: () => {
          this.handleExitIntent();
        },
      });
    }, 2000);
  },
  beforeDestroy() {
    if (this.removeExitIntent) {
      this.removeExitIntent();
    }
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.form-group.required {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 26px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 6px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-drop {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}
/* Multi Step Form CSS */
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}

.no-padding {
  padding-left: 8px;
  padding-top: 15px;
}

@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}
.on-exit {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9;
  .box {
    width: 670px;
    height: 350px;
    background: #fff;
    border-radius: 22px;
    border: 1px solid #ddd;
    padding: 22px;
    position: relative;
    background: url('../../../public/img/landing-pages/wait.png') no-repeat;
    background-color: #fff;
    background-size: contain;
    .content {
      position: relative;
      display: flex;
      .close-button {
        position: absolute;
        top: 0px;
        right: 20px;
        cursor: pointer;
        font-weight: 900;
        color: #666;
      }
      .text {
        padding: 30px 0;
        width: 50%;
        margin-left: auto;
        h3 {
          font-weight: 900;
          color: #f26622;
          font-size: 26px;
          margin-bottom: 20px;
        }
        p {
          font-size: 15px;
        }
        .btn-secondary {
          padding: 8px 30px;
          font-size: 18px;
          font-weight: 600;
        }
      }
    }
  }
}
.brands {
  padding: 50px 0;

  h3 {
    text-transform: uppercase;
    text-align: center;
    font-size: 34px;
    margin-bottom: 50px;
  }
  img {
    filter: grayscale(100%);
    &:hover {
      filter: grayscale(0);
    }
  }
}
.landing-page-employers {
  padding-top: 70px;
  .main-header {
    position: relative;
    min-height: 100vh;
    background: url('../../../public/img/landing-pages/Header.jpg');
    background-size: cover;
    margin: 0;
    .center-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        text-align: center;
        width: 335px;
        padding-top: 100px;
        img {
          width: 180px;
          height: 180px;
        }
        h1 {
          font-size: 2.1rem;
          span {
            font-weight: 900;
            display: block;
          }
        }
      }
    }
  }

  .content-section-gray {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    background-color: #ebeced;

    .content {
      text-align: center;
      padding: 0 120px;

      h2 {
        text-transform: uppercase;
        margin: 0 0 40px 0;
        font-size: 2rem;
        font-weight: 500;
        span {
          display: block;
        }
        &.bold {
          font-weight: 900;
          text-align: center;
          margin: 0px 0 30px 0;
          font-size: 36px;
        }
        &.sm {
          font-size: 1.6rem;
        }
      }
      p {
        font-size: 21px;
      }
      .d-flex {
        margin: 40px 0 0 0;
        justify-content: space-evenly;
        .btn {
          padding: 12px 0;
          font-size: 16px;
          width: 40%;
        }
      }
      &.no-padding {
        padding: 0;
      }
      .cube {
        img {
          width: 240px;
          height: auto;
        }
        h3 {
          font-size: 1.2rem;
          margin: 0 auto 12px auto;
        }
        p {
          font-size: 16px;
        }
      }
      .btn-block {
        margin-top: 30px;
        text-transform: uppercase;
        padding: 8px;
      }
    }
  }

  .content-section-white {
    padding: 50px 0;
    background-color: #fff;

    .content {
      h3 {
        font-weight: 900;
        text-align: center;
        margin: 40px 0 0px 0;
        font-size: 36px;
      }
    }

    .info-box {
      position: relative;
      margin: 100px auto;

      .col-md-6 {
        z-index: 999;
      }

      h3 {
        text-transform: uppercase;
        text-align: left;
        font-size: 2.2rem;
        font-weight: 400;
        z-index: 9999;

        span {
          display: block;
        }
      }

      p {
        font-size: 21px;
        margin-bottom: 80px;
      }

      .image-box {
        position: relative;

        .shadow-number {
          position: absolute;
          top: -385px;
          left: 255px;
          font-size: 348px;
          font-weight: 900;
          color: #ebeced;
          z-index: 0;
          height: 100px;
          opacity: 0.8;
          &.upper {
            top: -390px;
          }
        }

        img {
          width: 100%;
        }
      }
    }
  }
  .black-section {
    height: 260px;
    background: #222325;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 180px;
      height: auto;
      margin-right: 40px;
      flex-shrink: 0;
    }
    .text {
      text-align: right;
      align-items: center;
      p {
        font-size: 24px;
      }
    }
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .landing-page-employers {
    .main-header {
      min-height: 50vh;
      background-position: top;
      background-size: 1000px;
      .center-text {
        .text {
          h1 {
            font-size: 1.1rem;
            padding: 0 30px;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
      }
    }

    .content-section-white {
      overflow: hidden;
      .content {
        h3 {
          font-size: 32px;
        }
      }
      .info-box {
        margin: 25px auto;
        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 601px) and (max-width: 768px) {
  .landing-page-employers {
    .main-header {
      min-height: 55vh;
      background-position: top;
      background-size: 1000px;
      .center-text {
        .text {
          h1 {
            font-size: 1.4rem;
            padding: 0 30px;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
      }
    }

    .content-section-white {
      .content {
        h3 {
          font-size: 32px;
        }
      }
      .info-box {
        margin: 25px auto;
        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Medium devices (landscape tablets, 769px and up) */
@media only screen and (min-width: 769px) and (max-width: 992px) {
  .landing-page-employers {
    .main-header {
      min-height: 55vh;
      background-position: top;
      background-size: 1000px;
      .center-text {
        .text {
          h1 {
            font-size: 1.4rem;
            padding: 0 30px;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
      }
    }

    .content-section-white {
      .container {
        min-width: 100% !important;
      }
      .content {
        h3 {
          font-size: 32px;
        }
      }
      .info-box {
        margin: 25px auto;
        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Large devices (laptops/desktops, 993px and up) */
@media only screen and (min-width: 993px) and (max-width: 1200px) {
  /* Your styles here */
}

/* Extra large devices (large laptops and desktops, 1201px and up) */
@media only screen and (min-width: 1201px) {
  /* Your styles here */
}
</style>
